import {useEffect,useState} from 'react';
import type {MediaAsset} from '../types';
import {getLocalAsset} from './media-download';
export function useMediaUrl(media:MediaAsset,userId:string,thumbnail=false,onMissing?:()=>void,onReadError?:()=>void){
  const server=media.stored_on_device?'':`/api/media/${media.id}/${thumbnail&&(media.kind.includes('image')||media.kind==='final_frame')?'thumbnail':'content'}`;
  const [url,setUrl]=useState(server);
  useEffect(()=>{
    if(!media.stored_on_device){setUrl(server);return}
    let active=true,local='';
    setUrl('');
    void getLocalAsset(userId,media.id).then(row=>{if(!active)return;if(!row){onMissing?.();return}local=URL.createObjectURL(row.blob);setUrl(local)}).catch(()=>{if(active)onReadError?.()});
    return()=>{active=false;if(local)URL.revokeObjectURL(local)};
  },[media.id,media.stored_on_device,userId,server]);
  return url;
}
export function MediaPreview({media,userId,onMissing,controls=false}:{media:MediaAsset;userId:string;onMissing?:()=>void;controls?:boolean}){
  const [error,setError]=useState(false);
  const url=useMediaUrl(media,userId,!controls,onMissing,()=>setError(true));
  useEffect(()=>setError(false),[media.id,media.stored_on_device]);
  if(error)return <span className="muted" role="status">Не удалось показать файл. Он не удалён. Попробуйте открыть его через «Скачать».</span>;
  if(!url)return <span className="muted">Загрузка…</span>;
  if(media.kind.includes('image')||media.kind==='final_frame')return <img src={url} loading="eager" decoding="async" alt={media.original_name||'Изображение'} onError={()=>setError(true)}/>;
  if(media.kind.includes('video'))return <video src={url} controls={controls} preload="metadata" playsInline onError={()=>setError(true)}/>;
  if(media.kind.includes('audio'))return controls?<audio src={url} controls preload="metadata" onError={()=>setError(true)}/>:<span aria-label="Аудиофайл">♫</span>;
  return <span>Файл</span>;
}
